/* Eyeshells: device flags (iPad) for tablet-specific CSS hooks */
(function () {
  try {
    var ua = navigator.userAgent || '';
    // iPadOS 13+ may identify as Macintosh; touch-capable check catches it.
    var isIPad = /iPad/.test(ua) || (/Macintosh/.test(ua) && ('ontouchend' in document));
    if (isIPad) document.documentElement.classList.add('es-ipad');
  } catch (e) {}
})();

/**
 * ES: Unit conversion for specs ONLY (no正文污染)
 *
 * Goal:
 *  - 155 mm -> 155 mm / 6.1 in
 *  - 8 grams -> 8 grams / 0.3 ounces
 *
 * IMPORTANT:
 *  - Do NOT rely on changing product description templates.
 *  - Works even when number and unit are split across nodes:
 *      <span class="value">155</span>&nbsp;mm
 *  - PDP: only inside Details tab (#des) and only inside FRAME SIZE/spec list.
 *  - Quickview: only inside the quickview modal/spec container.
 */
(function () {
  'use strict';

  if (window.__esSpecUnitsCleanup) {
    try { window.__esSpecUnitsCleanup(); } catch (e) {}
  }

  var obs = null;
  var pageShowHandler = null;
  var pageHideHandler = null;
  var domReadyHandler = null;
  var modalShownHandler = null;
  var clickHandler = null;


  // ---- helpers ----
  function formatOneDecimal(n) {
    var s = n.toFixed(1);
    s = s.replace(/\.0+$/, '').replace(/(\.[0-9]*[1-9])0+$/, '$1');
    return s;
  }

  function textOf(el) {
    return ((el && el.textContent) ? el.textContent : '').replace(/\u00A0/g, ' ').trim();
  }

  function hasInches(text) {
    return /\/\s*\d+(?:\.\d+)?\s*in\b/i.test(text);
  }

  function hasOunces(text) {
    return /\/\s*\d+(?:\.\d+)?\s*ounce(s)?\b/i.test(text);
  }

  function getNumberFromEl(el) {
    // Prefer <span class="value">155</span>
    if (!el) return null;
    var v = el.querySelector ? el.querySelector('.value') : null;
    if (v && v.textContent) {
      var n = parseFloat(v.textContent.replace(/[^\d.]/g, ''));
      if (isFinite(n)) return n;
    }
    // Fallback: first number in text
    var m = textOf(el).match(/(\d+(?:\.\d+)?)/);
    if (m) {
      var n2 = parseFloat(m[1]);
      if (isFinite(n2)) return n2;
    }
    return null;
  }

  function appendText(el, txt) {
    if (!el) return;
    el.appendChild(document.createTextNode(txt));
  }

  function convertColorPrimary(colorPrimaryEl) {
    if (!colorPrimaryEl || colorPrimaryEl.nodeType !== 1) return;

    // Avoid double appending
    if (colorPrimaryEl.getAttribute('data-es-units-done') === '1') return;

    var t = textOf(colorPrimaryEl);
    if (!t) return;

    // mm -> in
    if (/\bmm\b/i.test(t) && !hasInches(t)) {
      var mm = getNumberFromEl(colorPrimaryEl);
      if (mm !== null) {
        appendText(colorPrimaryEl, ' / ' + formatOneDecimal(mm / 25.4) + ' in');
      }
    }

    // grams -> ounces
    if (/\bgrams?\b/i.test(t) && !hasOunces(t)) {
      var g = getNumberFromEl(colorPrimaryEl);
      if (g !== null) {
        var oz = g / 28.349523125;
        var ozStr = formatOneDecimal(oz);
        var ozNum = parseFloat(ozStr);
        var unit = (ozNum === 1) ? 'ounce' : 'ounces';
        appendText(colorPrimaryEl, ' / ' + ozStr + ' ' + unit);
      }
    }

    colorPrimaryEl.setAttribute('data-es-units-done', '1');
  }

  function normalizeWeightLabel(li) {
    if (!li || li.nodeType !== 1) return;
    if (li.getAttribute('data-es-weight-label') === '1') return;

    // Replace "Frame Weight:" -> "Weight:" in the first text nodes of the LI
    var changed = false;
    var nodes = li.childNodes || [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n && n.nodeType === 3 && n.nodeValue) {
        var before = n.nodeValue;
        var after = before.replace(/\bFrame\s*Weight\s*:/i, 'Weight:');
        if (after !== before) {
          n.nodeValue = after;
          changed = true;
          break;
        }
      }
    }

    // Fallback: if label is wrapped in an element
    if (!changed) {
      var t = textOf(li);
      if (/\bFrame\s*Weight\s*:/i.test(t)) {
        try {
          li.innerHTML = li.innerHTML.replace(/\bFrame\s*Weight\s*:/i, 'Weight:');
        } catch (e) {}
      }
    }

    li.setAttribute('data-es-weight-label', '1');
  }

  function normalizeSectionHeadings(root) {
    if (!root || root.nodeType !== 1) return;

    // 1) SPECIFICATIONS -> Specifications
    var specHeads = root.querySelectorAll('.specification .h2, .specification h2, .specification .font-black');
    for (var i = 0; i < specHeads.length; i++) {
      var h = specHeads[i];
      if (!h || h.getAttribute('data-es-spec-head') === '1') continue;
      var t = textOf(h);
      if (t && t.toUpperCase() === 'SPECIFICATIONS') {
        h.textContent = 'Specifications';
      }
      h.setAttribute('data-es-spec-head', '1');
    }

    // 2) FRAME SIZE -> Frame Measurements
    // (Weight is not strictly a size, so this label is more accurate.)
    var fsHeads = root.querySelectorAll('.frame-size h2, .frame-size .h2, h2');
    for (var j = 0; j < fsHeads.length; j++) {
      var hh = fsHeads[j];
      if (!hh || hh.getAttribute('data-es-fs-head') === '1') continue;
      var tt = textOf(hh);
      if (tt && tt.toUpperCase() === 'FRAME SIZE') {
        hh.textContent = 'Frame Measurements';
      }
      hh.setAttribute('data-es-fs-head', '1');
    }
  }

  function asArray(nodeList) {
    var arr = [];
    if (!nodeList) return arr;
    for (var i = 0; i < nodeList.length; i++) arr.push(nodeList[i]);
    return arr;
  }

  // ---- Scoped processing ----
  // We only convert in the specs list items (FRAME SIZE block) to avoid正文污染.
  var SPEC_LI_SELECTOR = [
    'li.frame-width',
    'li.lens-width',
    'li.bridge',
    'li.temple-length',
    'li.lens-height',
    'li.frame-weight'
  ].join(',');

  function processWithin(root) {
    if (!root || root.nodeType !== 1) return;

    // Normalize headings first (scoped to the spec blocks only)
    normalizeSectionHeadings(root);

    // 1) Preferred: your template uses these LI classes
    var lis = asArray(root.querySelectorAll(SPEC_LI_SELECTOR));
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      if (li && li.matches && li.matches('li.frame-weight')) normalizeWeightLabel(li);
      var cp = li.querySelector ? li.querySelector('.color-primary') : null;
      if (cp) convertColorPrimary(cp);
    }

    // 2) Fallback: if classes are missing, still limit to frame-size area if present
    var frameSize = root.querySelector ? root.querySelector('.frame-size') : null;
    if (frameSize) {
      var wlis = asArray(frameSize.querySelectorAll('li.frame-weight'));
      for (var wi = 0; wi < wlis.length; wi++) normalizeWeightLabel(wlis[wi]);
      var cps = asArray(frameSize.querySelectorAll('.color-primary'));
      for (var j = 0; j < cps.length; j++) {
        var txt = textOf(cps[j]);
        if (/\bmm\b/i.test(txt) || /\bgrams?\b/i.test(txt)) convertColorPrimary(cps[j]);
      }
    }
  }

  function processPDP() {
    // Only Details tab content
    var detailsPanes = asArray(document.querySelectorAll('.tab-pd-details #des'));
    for (var i = 0; i < detailsPanes.length; i++) processWithin(detailsPanes[i]);
  }

  function processQuickview() {
    // Quickview varies: try common containers
    var qvRoots = asArray(document.querySelectorAll(
      '.quickview-product, #quickviewModal, #ModalQuickView, .modal.quickview, .modal.quickview-product'
    ));
    for (var i = 0; i < qvRoots.length; i++) {
      // Often injected into .des inside modal
      var des = qvRoots[i].querySelector ? qvRoots[i].querySelector('.des') : null;
      processWithin(des || qvRoots[i]);
    }
  }

  function processAll() {
    processPDP();
    processQuickview();
  }

  // Allow ajax-rendered areas (for example Quickview variant/spec swaps)
  // to be processed immediately instead of waiting for MutationObserver timing.
  window.esProcessSpecUnits = function (root) {
    try {
      if (root && root.nodeType === 1) {
        processWithin(root);
      } else {
        processAll();
      }
    } catch (e) {}
  };

  // ---- scheduling / observers ----
  var scheduled = false;
  var delayedTimers = {};

  function clearDelayedTimers() {
    for (var key in delayedTimers) {
      if (!Object.prototype.hasOwnProperty.call(delayedTimers, key)) continue;
      if (!delayedTimers[key]) continue;
      try { clearTimeout(delayedTimers[key]); } catch (e) {}
      delayedTimers[key] = null;
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(function () {
      scheduled = false;
      processAll();
    }, 16);
  }

  function scheduleDelayed(key, ms) {
    if (delayedTimers[key]) clearTimeout(delayedTimers[key]);
    delayedTimers[key] = setTimeout(function () {
      delayedTimers[key] = null;
      processAll();
    }, ms);
  }

  function init() {
    processAll();

    // Content might render after tabs/modal injections.
    // Coalesce retries so rapid modal/tab activity doesn't pile up timers.
    scheduleDelayed('post-init-short', 300);
    scheduleDelayed('post-init-long', 1200);

    // Observe DOM changes (quickview injection, ajax, etc.)
    if (window.MutationObserver && document.body) {
      var RELEVANT_SELECTOR = '.quickview-product, #quickviewModal, #ModalQuickView, .modal.quickview, .modal.quickview-product, .tab-pd-details, #des, .des, .frame-size, li.frame-width, li.lens-width, li.bridge, li.temple-length, li.lens-height, li.frame-weight';
      function isRelevantNode(node) {
        try {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches(RELEVANT_SELECTOR)) return true;
          return !!(node.querySelector && node.querySelector(RELEVANT_SELECTOR));
        } catch (e) {
          return false;
        }
      }
      obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.target && isRelevantNode(m.target)) {
            schedule();
            break;
          }
          if (!m.addedNodes || !m.addedNodes.length) continue;
          for (var j = 0; j < m.addedNodes.length; j++) {
            if (isRelevantNode(m.addedNodes[j])) {
              schedule();
              return;
            }
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }

    // Bootstrap modal show event (best effort)
    modalShownHandler = function () {
      scheduleDelayed('modal', 50);
    };
    document.addEventListener('shown.bs.modal', modalShownHandler, true);

    // Tab clicks (best effort)
    clickHandler = function (e) {
      var t = e.target;
      if (!t) return;
      // If user clicks the tabs or quickview triggers, re-run
      var cls = (t.className || '');
      if (/underline_scale|tab_prod|quickview|quick-view|qv/i.test(cls)) {
        scheduleDelayed('interaction', 50);
      }
    };
    document.addEventListener('click', clickHandler, true);
  }

  function cleanup() {
    try { if (obs) obs.disconnect(); } catch (e) {}
    obs = null;
    clearDelayedTimers();
    if (domReadyHandler) {
      try { document.removeEventListener('DOMContentLoaded', domReadyHandler); } catch (e) {}
      domReadyHandler = null;
    }
    if (modalShownHandler) {
      try { document.removeEventListener('shown.bs.modal', modalShownHandler, true); } catch (e) {}
      modalShownHandler = null;
    }
    if (clickHandler) {
      try { document.removeEventListener('click', clickHandler, true); } catch (e) {}
      clickHandler = null;
    }
  }

  pageShowHandler = function () {
    cleanup();
    init();
  };
  pageHideHandler = function () {
    cleanup();
  };
  window.addEventListener('pageshow', pageShowHandler);
  window.addEventListener('pagehide', pageHideHandler);

  window.__esSpecUnitsCleanup = function () {
    cleanup();
    try { window.removeEventListener('pageshow', pageShowHandler); } catch (e) {}
    try { window.removeEventListener('pagehide', pageHideHandler); } catch (e) {}
  };

  if (document.readyState === 'loading') {
    domReadyHandler = init;
    document.addEventListener('DOMContentLoaded', domReadyHandler);
  } else {
    init();
  }
})();
